/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import * as React from "react";
import * as _ from "lodash";
import ILabTest from "../models/ILabTest";
import ModelFactory from "../models/ModelFactory";
import { labTestStyles } from "../styles/ongoing/labtests";

export interface LabTestRowProps {
    labTestRow: ILabTest;
    hideTitle?: boolean
}

class LabTestRow extends React.Component<LabTestRowProps> {
    constructor(props: LabTestRowProps) {
        super(props);
    }
    render() {
        let labTestRow = this.props.labTestRow;
        let labTestRows = labTestRow && !_.isEmpty(labTestRow.childCheckUpReportInfo) ? labTestRow.childCheckUpReportInfo : [];
        return (
            <div className={"labTest-row-container spaced"}>
                {
                    labTestRows.length > 0 &&
                    <div>
                        {!this.props.hideTitle && <div className={"labtTest-category brandon-bold"}>
                            {labTestRows[0].reportDetails.packageProfileName && labTestRows[0].reportDetails.packageProfileName.toUpperCase()}
                        </div>}

                        <table css={labTestStyles.table}>
                            <tbody>
                                <tr css={labTestStyles.tableHeader}> 
                                    <td css={labTestStyles.tableCol}>Markers</td>
                                    <td css={labTestStyles.tableCol}>Results</td>
                                    <td css={labTestStyles.tableCol}>Units</td>
                                </tr>
                                {
                                    _.map(labTestRows, (labTest, index) => {
                                        if (!_.isEmpty(labTest.reportDetails)) {
                                            return (<tr key={`labTest-${index}`}>
                                                <td css={labTestStyles.mobileFont}>
                                                    <div className={"brandon-bold"}>{labTest.reportDetails.testName}</div>
                                                </td>
                                                <td css={labTestStyles.mobileFont}>
                                                    <div>
                                                        {labTest.reportDetails.testResultValue}
                                                    </div>
                                                </td>
                                                <td css={labTestStyles.mobileFont}>
                                                    <div>{labTest.reportDetails.testMeasuringUnit}</div>
                                                </td>
                                            </tr>)
                                        }
                                    })
                                }
                            </tbody>
                        </table>


                    </div>
                }
                {
                    labTestRows.length === 0 && !_.isNull(labTestRow.reportDetails) &&
                    <div>
                        <div className={"labtTest-category brandon-bold"}>
                            {labTestRow.reportDetails.packageProfileName.toUpperCase()}
                        </div>
                        <div className={"lab-test"} style={{ display: "inline-block" }}>
                            <div className={"brandon-bold"}>{labTestRow.reportDetails.testName}</div>
                            <div className={"labTest-value"}>
                                {labTestRow.reportDetails.testResultValue}
                                <span className={"measuring-unit"}>{labTestRow.reportDetails.testMeasuringUnit}</span>
                            </div>
                        </div>
                    </div>

                }
            </div>
        )
    }
}

export default LabTestRow;